import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=59645c71&scoped=true&"
import script from "./PostEdit.vue?vue&type=script&lang=js&"
export * from "./PostEdit.vue?vue&type=script&lang=js&"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=59645c71&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59645c71",
  null
  
)

export default component.exports